import * as React from 'react';

import { Skeleton } from '../../ui/skeleton';
import { TableCell, TableRow } from '../../ui/table';

export interface TableLoadingSkeletonProps {
  /** Number of skeleton columns per row */
  columns: number;
  /** Number of skeleton rows to render (default: 3) */
  rows?: number;
}

export function TableLoadingSkeleton({ columns, rows = 3 }: TableLoadingSkeletonProps): React.JSX.Element {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <TableRow key={i}>
          {Array.from({ length: columns }, (__, j) => (
            <TableCell key={j}>
              <Skeleton className="h-4 w-full" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
